import { useState } from "react";
import { Volume2, Check } from "lucide-react";
import { motion } from "framer-motion";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1665064914191-6512af753429?w=600&fit=crop&q=80";

export const WordCard = ({ word, index = 0, onLearn, isLearned = false, showDetails = false }) => {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08 }}
      className="group relative overflow-hidden rounded-2xl bg-nordic-paper shadow-sm hover:shadow-xl border border-nordic-wood/10"
      style={{ transition: "box-shadow 0.4s ease" }}
      data-testid={`word-card-${word.swedish}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {!imgLoaded && <div className="absolute inset-0 img-placeholder animate-pulse" />}
        <img
          src={word.image_url}
          alt={word.english}
          loading="lazy"
          onLoad={() => setImgLoaded(true)}
          onError={(e) => { if (e.target.src !== FALLBACK_IMG) e.target.src = FALLBACK_IMG; }}
          className={`w-full h-full object-cover group-hover:scale-105 ${imgLoaded ? 'opacity-100' : 'opacity-0'}`}
          style={{ transition: "transform 0.6s ease, opacity 0.3s ease" }}
        />
        {isLearned && (
          <div className="absolute top-3 right-3 bg-nordic-success text-white rounded-full p-1.5" data-testid={`learned-badge-${word.swedish}`}>
            <Check className="w-4 h-4" />
          </div>
        )}
      </div>

      <div className="p-5">
        <div className="flex items-baseline justify-between mb-1">
          <h3 className="font-heading text-2xl font-medium text-nordic-text">{word.swedish}</h3>
          <span className="text-sm text-nordic-text-muted font-body">{word.pronunciation}</span>
        </div>
        <p className="text-nordic-text-secondary text-base">{word.english}</p>

        {showDetails && (
          <div className="mt-4 pt-4 border-t border-nordic-wood/10">
            <p className="text-sm text-nordic-text italic font-accent">"{word.example_sentence}"</p>
            <p className="text-xs text-nordic-text-muted mt-1">{word.example_translation}</p>
          </div>
        )}

        {onLearn && !isLearned && (
          <button
            onClick={() => onLearn(word.id)}
            className="mt-3 text-sm text-nordic-blue hover:text-nordic-blue-light font-medium"
            style={{ transition: "color 0.2s ease" }}
            data-testid={`learn-btn-${word.swedish}`}
          >
            Mark as learned
          </button>
        )}
      </div>
    </motion.div>
  );
};
